<template>
  <el-dialog :visible.sync="showDialog" width="780px" :close-on-click-modal="false">
    <div slot="title" class="rulesetting--form__title">
      {{ $t('storage::stock-analysis::rule_setting') }}
      <el-tooltip effect="dark" :content="$t('storage::stock-analysis::rule_set_tips')" placement="top-start">
        <i class="el-icon-question" style="color: #999999"></i>
      </el-tooltip>
    </div>
    <el-form class="rulesetting--form">
      <el-form-item>
        <template slot="label">
          <span class="rulesetting--form__label">{{ $t('storage::stock-analysis::full_days') }}</span>
        </template>
        <div>
          {{ $t('storage::stock-analysis::可用库存 / 近') }}
          <el-input-number
            class="rulesetting--form__input"
            :min="0"
            :max="30"
            controls-position="right"
            @change="val => checkDay(val, 'satisfyDays')"
            v-model="ruleSet.satisfyDays"
          ></el-input-number>
          {{ $t('storage::stock-analysis::天日均销量') }}
        </div>
      </el-form-item>
      <el-form-item>
        <template slot="label">
          <span class="rulesetting--form__label">{{ $t('storage::stock-analysis::purchase_suggest') }}</span>
        </template>
        <div>
          {{ $t('storage::stock-analysis::当满足天数少于') }}
          <el-input-number
            class="rulesetting--form__input"
            :min="0"
            :max="30"
            @change="val => checkDay(val, 'purchaseDays')"
            v-model="ruleSet.purchaseDays"
            controls-position="right"
          ></el-input-number>
          {{ $t('storage::stock-analysis::天时该SPU为建议采购') }}
        </div>
      </el-form-item>
      <el-form-item>
        <template slot="label">
          <span class="rulesetting--form__label">{{ $t('storage::stock-analysis::sales_rise') }}</span>
        </template>
        <div>
          {{ $t('storage::stock-analysis::本周期') }}
          <el-input-number
            class="rulesetting--form__input"
            :min="0"
            :max="30"
            v-model="ruleSet.cycleUpDays"
            @change="val => checkDay(val, 'cycleUpDays')"
            controls-position="right"
          ></el-input-number>
          {{ $t('storage::stock-analysis::天环比上一周期销量上涨') }}
          <el-input-number
            class="rulesetting--form__input"
            :min="0"
            v-model="ruleSet.cycleUpPercentage"
            controls-position="right"
          ></el-input-number>
          %, {{ $t('storage::stock-analysis::该SPU为销量上涨') }}
        </div>
      </el-form-item>
      <el-form-item>
        <template slot="label">
          <span class="rulesetting--form__label">{{ $t('storage::stock-analysis::sales_down') }}</span>
        </template>
        <div>
          {{ $t('storage::stock-analysis::本周期') }}
          <el-input-number
            class="rulesetting--form__input"
            :min="0"
            :max="30"
            @change="val => checkDay(val, 'cycleDownDays')"
            v-model="ruleSet.cycleDownDays"
            controls-position="right"
          ></el-input-number>
          {{ $t('storage::stock-analysis::天环比上一周期销量下降') }}
          <el-input-number
            class="rulesetting--form__input"
            :min="0"
            v-model="ruleSet.cycleDownPercentage"
            controls-position="right"
          ></el-input-number>
          %，{{ $t('storage::stock-analysis::该SPU为销量下降') }}
        </div>
      </el-form-item>
      <el-form-item>
        <template slot="label">
          <span class="rulesetting--form__label" style="margin-right: 12px">
            {{ $t('storage::stock-analysis::un_move') }}
          </span>
        </template>
        <div>
          {{ $t('storage::stock-analysis::近') }}
          <el-input-number
            class="rulesetting--form__input"
            :min="0"
            :max="30"
            @change="val => checkDay(val, 'fixPinDays')"
            v-model="ruleSet.fixPinDays"
            controls-position="right"
          ></el-input-number>
          {{ $t('storage::stock-analysis::天销量为零该SPU为不动销商品') }}
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" style="text-align: center">
      <el-button size="small" style="width: 96px" @click="showDialog = false">
        {{ $t('system::common::btn::cancel') }}
      </el-button>
      <el-button type="primary" size="small" style="width: 96px" @click="saveRule">
        {{ $t('system::common::btn::save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getStockRule, saveStockRule } from '@/server/stock'

export default {
  name: 'RuleSetting',
  data() {
    return {
      showDialog: false,
      ruleSet: {
        satisfyDays: '',
        purchaseDays: '',
        cycleUpDays: '',
        cycleUpPercentage: '',
        cycleDownDays: '',
        cycleDownPercentage: '',
        fixPinDays: '',
      },
    }
  },
  methods: {
    show() {
      this.getRule()
      this.showDialog = true
    },
    async getRule() {
      const { data } = await getStockRule()
      if (data.code === this.$code) {
        this.ruleSet = data.data
      }
    },
    async saveRule() {
      const { data } = await saveStockRule(this.ruleSet)
      if (data.code === this.$code) {
        this.showDialog = false
        this.$message.success($t('system::tip::save_success'))
        this.$emit('success')
      }
    },
    checkDay(val, key) {
      const reg = /^[0-9]+$/
      if (!reg.test(val)) {
        this.$nextTick(() => {
          this.ruleSet[key] = parseInt(val)
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.rulesetting--form {
  color: #010517;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  line-height: 19px;
  &__title {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #010517;
    line-height: 20px;
  }
  &__label {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    line-height: 19px;
    margin-right: 25px;
  }
  &__input {
    width: 110px;
    margin: 0 8px;
  }
}
</style>
